<template>
  <section class="mt-50 mb-50 our_team" id="team-section">
    <div class="container">
      <div class="row mb-5 justify-content-center">
        <div class="col-md-8 text-center">
          <h2 class="section-title mb-3" data-aos="fade-up" data-aos-delay>Meet Our Team</h2>
          <p
            class="lead"
            data-aos="fade-up"
            data-aos-delay="100"
          >Our strong, dedicated team of specialists, who are driven by the company’s main idea to provide customized debt relief for small businesses, ensure reliability and high efficiency.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-3 mb-4" v-for="person in team" :key="person.id">
          <div class="team-member">
            <figure>
              <ul class="social">
                <li>
                  <a href="#">
                    <i class="fab fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="fab fa-linkedin-in"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
              <img :src="require(`../assets/${person.avatar}`)" alt="Image" class="img-fluid" />
            </figure>
            <div class="p-3">
              <h3>{{person.name}}</h3>
              <span class="position">{{person.position}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      team: [
        {
          name: "Kaiara Spencer",
          position: "Finance Manager",
          avatar: "person_5.jpg",
          id: 1
        },
        {
          name: "Roberto",
          position: "Finance assistant",
          avatar: "person_5.jpg",
          id: 2
        },
        {
          name: "Ihor",
          position: "Developer",
          avatar: "person_5.jpg",
          id: 3
        },
        {
          name: "Yasha",
          position: "Accounter",
          avatar: "person_5.jpg",
          id: 4
        },
        {
          name: "Pavlik",
          position: "Trash",
          avatar: "person_5.jpg",
          id: 5
        }
      ]
    };
  }
};
</script>


<style lang="scss" scoped>
.team-member figure {
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.team-member .social {
  position: absolute;
  margin: 0;
  top: 0;
  padding: 0;
  bottom: 0;
  padding: 10px;
  -webkit-transform: translateX(-101%);
  -ms-transform: translateX(-101%);
  transform: translateX(-101%);
  -webkit-transition: 0.3s all ease;
  -o-transition: 0.3s all ease;
  transition: 0.3s all ease;
  background: #4460fd;
}
.team-member .social li {
  list-style: none;
}
.team-member .social li a {
  display: inline-block;
  padding: 5px;
  color: #fff;
  font-size: 18px;
}

.team-member h3 {
  color: #000;
  margin: 0;
  bottom: 0;
  font-size: 1.2rem;
}

.team-member .position {
  color: #cccccc;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.05rem;
}

.team-member:hover .social {
  -webkit-transform: translateX(0%);
  -ms-transform: translateX(0%);
  transform: translateX(0%);
}
</style>